import { ref } from 'vue'

export type ChatRailMode = 'client' | 'agent'

// Estado de módulo (singleton) — ConvDrawer e AgentChatDrawer compartilham o
// mesmo trilho de 60px à direita: só um dos dois strips fica visível por vez,
// alternado pelo botão no rodapé de cada um (mesmo botão visual, ícone
// diferente por modo).
const mode = ref<ChatRailMode>('client')

export function useChatRailMode() {
  function toggle() {
    mode.value = mode.value === 'client' ? 'agent' : 'client'
  }
  return { mode, toggle }
}
